/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Image from '@Uilib/h3Image';
import searchIcon from '@Images/icons/icon-search.png';
import QCPointActions from '@Actions/quality/qcPointActions';
import ProductActions from '@Actions/productActions';
import { Select, Table, Popconfirm } from 'antd';
import {
  CloseOutlined,
} from '@ant-design/icons';
import PRZModal from '../../../Common/UI/PRZModal';
import './style.scss';

/**
 *
 */
const UpdateProductGroup = ({
  getQCPointById, getQCPointByIdLoading, deleteQCPointLoading, user, deleteQCPoint, selectedQCPoint, selectedQCPointById, onClose,
}) => {
  const [isDelete, setIsDelete] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [showPRZModal, setShowPRZModal] = useState(false);
  const [currentProduct, setCurrentProduct] = useState('');

  useEffect(() => {
    getQCPointById(user?.tenant_info?.tenant_id, selectedQCPoint?.group_id);
  }, []);

  useEffect(() => {
    getQCPointById(user?.tenant_info?.tenant_id, selectedQCPoint?.group_id);
    setIsDelete(false);
  }, [isDelete]);

  const getGroupedProductsColumns = () => {
    const groupedProducts = [
      {
        title: 'SKU#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (
          <div onClick={() => {
            setShowPRZModal(true);
            setCurrentProduct(record?.product_sku_id);
            }}>
            <a>
            {`#${record?.internal_sku_code}`}
            </a>
          </div>
        ),
      },
      {
        title: 'Product Name',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => (
          <div>
            {item?.product_sku_name}
          </div>
        ),
      },
      {
        title: '',
        render: (text, record) => (
          <Fragment>
            <Popconfirm
              placement="topRight"
              title="Are you sure you want remove this product?"
              onConfirm={() => {
                const payload = {
                  tenant_id: user?.tenant_info?.tenant_id,
                  product_sku_id: record?.product_sku_id,
                };
                deleteQCPoint(payload, () => {
                  if (selectedQCPointById?.products?.length === 1) {
                    onClose();
                  }
                  setIsDelete(true);
                });
              }}
              okText="Yes"
              cancelText="No"
            >
              <div
                className="update-product-group__icon"
              >
                <CloseOutlined />
              </div>
            </Popconfirm>
          </Fragment>
        ),
        width: '40px',
      },
    ];
    return groupedProducts;
  };

  return (
    <Fragment>
      <div className="update-product-group__wrapper" style={{ marginBottom: '40px' }}>
        <div className="ant-row">
          <div className="ant-col-md-24">
            {selectedQCPointById?.products?.length > 4 && (
              <div className="update-product-group__list-search">
                <input
                  placeholder="search product.."
                  onChange={(event) => setSearchKeyword(event.target.value)}
                />
                <H3Image src={searchIcon} className="update-product-group__list-search-icon" />
              </div>
            )}
            <div className="update-product-group__table-container">
              <Table
                title={() => (
                  <div className="pending-so__table-header">
                    {`${selectedQCPointById?.products?.filter((item) => (
                  item?.product_sku_name?.toLowerCase()?.includes(searchKeyword?.toLowerCase())))?.length || '0'} Products`}
                  </div>
                )}
                loading={getQCPointByIdLoading || deleteQCPointLoading}
                showHeader
                size="small"
                columns={getGroupedProductsColumns()}
                dataSource={selectedQCPointById?.products?.filter((item) => (
                  item?.product_sku_name?.toLowerCase()?.includes(searchKeyword?.toLowerCase()))) || []}
                bordered
                pagination={{
                  position: ['bottomRight'],
                  showSizeChanger: false,
                }}
              />
              <PRZModal
                isOpen={showPRZModal}
                onClose={() => {
                  setShowPRZModal(false);
                  setCurrentProduct(null);
                }}
                entityType="product"
                documentId={currentProduct}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, QCPointReducers, CategoryReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  deleteQCPointLoading: QCPointReducers.updateQCPointLoading,
  getQCPointByIdLoading: QCPointReducers.getQCPointByIdLoading,
  selectedQCPointById: QCPointReducers.selectedQCPointById,
  categories: CategoryReducers.categories,
  products: ProductReducers.products,
});

const mapDispatchToProps = (dispatch) => ({
  deleteQCPoint: (payload, callback) => dispatch(QCPointActions.deleteQCPoint(payload, callback)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct)),
  getQCPointById: (tenantId, groupId) => dispatch(
    QCPointActions.getQCPointById(tenantId, groupId),
  ),
});

UpdateProductGroup.propTypes = {
  user: PropTypes.any,
  productsGroup: PropTypes.any,
  products: PropTypes.any,
  getQCPointByIdLoading: PropTypes.bool,
  callback: PropTypes.func,
  getQCPointById: PropTypes.func,
  selectedQCPoint: PropTypes.any,
  selectedQCPointById: PropTypes.any,
  deleteQCPoint: PropTypes.any,
  deleteQCPointLoading: PropTypes.any,
  onClose: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateProductGroup));
